const strings = {
  en: {
    label: 'Customer Stories',
    title: 'See How Teams Use SAPOT.AI',
    prevSlideMessage: 'Previous testimonial',
    nextSlideMessage: 'Next testimonial',
  },
  zh: {
    label: '客户案例',
    title: '看看团队如何使用 SAPOT.AI',
    prevSlideMessage: '上一条评价',
    nextSlideMessage: '下一条评价',
  },
};

export default strings;
